import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorStateService, RegistrationStepService, StepType } from '@fgb/core';

@Component({
  selector: 'fgbcl-registration-refer-a-friend',
  templateUrl: './registration-refer-a-friend.component.html',
  styleUrl: './registration-refer-a-friend.component.scss',
})
export class RegistrationReferAFriendPageComponent implements OnInit {
  readonly stepType = StepType.ReferAFriend;
  loading: boolean = false;
  showBackButton: boolean = false;

  constructor(
    private registrationStepService: RegistrationStepService,
    private errorStateService: ErrorStateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.registrationStepService
      .submitRegistrationStepData(this.stepType, {})
      .toPromise()
      .then(() => {
        this.loading = false;
        this.showBackButton = this.errorStateService.hasErrors();
      });
  }

  backToLogin(): void {
    this.registrationStepService.clearQueryData();
    this.router.navigate(['/login']);
  }
}
